<template>
    <v-tabs 
        class="round-card"
        height="34"
        background-color="background-1"
        slider-color="primary">
        <v-tab key="Campi" ripple class="secondary-tab">
            Campi
        </v-tab>
        <v-tab key="Azioni" ripple class="secondary-tab">
            Azioni
        </v-tab>
        <v-tab key="Categorie" ripple class="secondary-tab">
            Categorie
        </v-tab>
        <v-tab key="Altro" ripple class="secondary-tab">
            Altro
        </v-tab>

        <v-tab-item class="background-1 pt-3 pb-1" key="Campi">
            <v-row class="ma-0">
                
                <v-col class="pa-0 pt-2" cols="12">
                    <fields-selector
                        model-def="asset"
                        :totals="[{ label: 'Totali prodotti', infoTotals: 'info_totals' }]"
                    ></fields-selector>
                </v-col>

            </v-row>
            <v-tabs 
                class="tabs-pill mt-4"
                height="34"
                background-color="background-1"
                slider-color="primary">
                <v-tab key="Campi" ripple class="secondary-tab">
                    Campi
                </v-tab>
        
                <v-tab-item class="pb-offset background-1 pt-3" key="Campi">
                    <v-row class="ma-0 pb-offset">
                        
                        <v-col class="pa-0 pt-2" cols="12">
                            <fields-selector model-def="assetproduct" audit></fields-selector>
                        </v-col>
        
                    </v-row>
                </v-tab-item>
                
            </v-tabs>
        </v-tab-item>
        
        <v-tab-item class="background-1 pt-3 pb-1" key="Azioni">
            <v-row class="ma-0">
                
                <v-col class="pa-0 pt-2" cols="12">
                    <actions-selector model-def="asset"></actions-selector>
                </v-col>

            </v-row>
        </v-tab-item>

        <v-tab-item class="background-1 pt-3 pb-1" key="Categorie">
            <v-row class="ma-0">
                <v-col class="pa-0 pb-4" cols="12">
                    <crud
                        :title="'Tipo ' + $trans('asset')"
                        action-icon='settings'
                        model-def='generaltypes-asset_type'
                        action-position='absolute'
                        crudDialog
                    ></crud>
                </v-col>
                <template v-if="$store.getters.checkModulePermissions('mikrotik')">
                    <v-col class="pa-0 pb-4" cols="12">
                        <crud
                            title="Fornitore connettività"
                            action-icon='settings'
                            model-def='generaltypes-connectivity_supplier'
                            action-position='absolute'
                            crudDialog
                        ></crud>
                    </v-col>
                    <v-col class="pa-0 pb-4" cols="12">
                        <crud
                            title="Tipo connessione"
                            action-icon='settings'
                            model-def='generaltypes-connectivity_type'
                            action-position='absolute'
                            crudDialog
                        ></crud>
                    </v-col>
                    <v-col class="pa-0 pb-4" cols="12">
                        <crud
                            title="Velocità connessione"
                            action-icon='settings'
                            model-def='generaltypes-connectivity_speed'
                            action-position='absolute'
                            crudDialog
                        ></crud>
                    </v-col>
                    <v-col class="pa-0 pb-4" cols="12">
                        <crud
                            title="Modello router"
                            action-icon='settings'
                            model-def='generaltypes-router_model'
                            action-position='absolute'
                            crudDialog
                        ></crud>
                    </v-col>                
                </template>
            </v-row>
        </v-tab-item>
        
        <v-tab-item class="background-1 pt-3 pb-1" key="Altro">
            <v-row class="ma-0">
                <assets-options></assets-options>
            </v-row>
        </v-tab-item>
    </v-tabs>
</template>
<script>

import FieldsSelector from '@/components/common/FieldsSelector'
import ActionsSelector from '@/components/common/ActionsSelector'
import AssetsOptions from '@/components/modules/assets/settings/AssetsOptions'

	export default {
		name:'assets-settings',
        components: {
            AssetsOptions,
			FieldsSelector,
			ActionsSelector,
        },		
		data() {
			return {

			}
		},
	}
  </script>
